import React, { useEffect } from 'react';
import { useAppSelector } from '../../../../infra/hooks';
import { jobInfoType } from '../../../../common/interfaces/myProfile/personalDetails/jobInfo';

interface PropsValues {
  setJobInfo: (data: jobInfoType) => void;
}

function DTOJobInfo({ setJobInfo }: PropsValues) {
  const selector = useAppSelector((state) => state.jobInfoSlice);

  useEffect(() => {
    const job_info_data: jobInfoType = {
      contractType: selector.contractType,
      departmentName: selector.departmentName,
      hireDate: selector.hireDate,
      employeeCategory: selector.employeeCategory,
      employeeType: selector.employeeType,
      payrollType: selector.payrollType,
      staffId: selector.staffId,
      extNo: selector.extNo,
      isDirectManager: selector.isDirectManager,
      isDirectManagerStffId: selector.isDirectManagerStffId,
      grade: selector.grade,
    };
    setJobInfo(job_info_data);
  }, [selector]);

  return <></>;
}
export default DTOJobInfo;
